import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=ab4b46f2&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=ab4b46f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4b46f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab4b46f2')) {
      api.createRecord('ab4b46f2', component.options)
    } else {
      api.reload('ab4b46f2', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=ab4b46f2&scoped=true&", function () {
      api.rerender('ab4b46f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ien3JImsJ9YC/JS/comp/DocBox.vue"
export default component.exports